import { render } from "./WGroupedSelectorGroup.vue?vue&type=template&id=5bb08bca"
import script from "./WGroupedSelectorGroup.vue?vue&type=script&lang=js"
export * from "./WGroupedSelectorGroup.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__